import { IVesselFormData } from "../../../../shared/sharedTypes";
import { TSubscribedMsiVessel } from "../../../../user-management/subscription/subscriptionTypes";
import { SectorFilterOptions } from "../enums";
import { OwnershipFilter } from "./OwnershipFilter";
import { Sector } from "./Sector";
import { SectorFilter } from "./SectorFilter";
import { includes } from 'lodash';

export class FilterWrapper {

    ownershipFilter: OwnershipFilter;
    sectorFilter: SectorFilter;

    constructor(ownerships?: string, sectors?: string) {
        this.ownershipFilter = new OwnershipFilter(ownerships || "[]");
        this.sectorFilter = new SectorFilter(sectors || "[]");
    }

    static applyFilters(subscribedMsiVessels: TSubscribedMsiVessel[], ownerships: string[], sectors: Sector[]): IVesselFormData[] {
        let ownershipsFilterAppliedMsiVesselList = [...subscribedMsiVessels];
        if (ownerships.length > 0) {
            ownershipsFilterAppliedMsiVesselList = ownershipsFilterAppliedMsiVesselList.filter(vessel => ownerships.includes(vessel.owner))
        }
        const filterAppliedMsiVesselList: TSubscribedMsiVessel[] = [];
        if (sectors.length > 0) {

            sectors.forEach(sector => {
                let tempSectorsAppliedMsiVesselList = [...ownershipsFilterAppliedMsiVesselList];
                if (sector.selection === SectorFilterOptions.ALL) {
                    tempSectorsAppliedMsiVesselList = tempSectorsAppliedMsiVesselList?.filter(vessel => vessel.sectorCode === sector.sectorCode);
                }
                else if (sector.selection === SectorFilterOptions.NONE) {
                    // tempSectorsAppliedMsiVesselList = tempSectorsAppliedMsiVesselList?.filter(vessel => vessel.sectorCode !== sector.sectorCode);
                    return
                }
                else if (sector.selection === SectorFilterOptions.FILTER) {
                    tempSectorsAppliedMsiVesselList = tempSectorsAppliedMsiVesselList?.filter(vessel => vessel.sectorCode === sector.sectorCode);
                    sector.filters.forEach(field => {
                        if (field.componentId.includes('max')) {
                            tempSectorsAppliedMsiVesselList = tempSectorsAppliedMsiVesselList?.filter(vessel => vessel[field.name.toString()] <= field.value);
                        }
                        else if (field.componentId.includes('min')) {
                            tempSectorsAppliedMsiVesselList = tempSectorsAppliedMsiVesselList?.filter(vessel => vessel[field.name.toString()] >= field.value);
                        }
                        else {
                            tempSectorsAppliedMsiVesselList = tempSectorsAppliedMsiVesselList?.filter(vessel => includes(field.value.toString().split(','), vessel[field.name.toString()]));
                        }
                    });
                    if (tempSectorsAppliedMsiVesselList.length === 0) {
                        return;
                    }
                }
                filterAppliedMsiVesselList.push(...tempSectorsAppliedMsiVesselList);
            });
        }
        return filterAppliedMsiVesselList?.map((v) => ({ name: v.vesselName, imoNumber: v.imoNumber, sectorName: v.sectorName, companyName: v.owner })) ?? [] as IVesselFormData[];
    }
}